// tslint:disable:max-line-length
import { createAction, props } from '@ngrx/store';
import { PagedOverview } from 'src/app/core/models';
import { Story, StoryData, UpdateStoryData } from '../../models';

export const LoadStory = createAction('[Stories] Load Story', props<{ id: number }>());
export const LoadStorySuccess = createAction('[Stories] Load Story Success', props<{ story: Story }>());
export const LoadStoryFail = createAction('[Stories] Load Story Fail', props<{ error: any }>());

export const LoadStories = createAction('[Stories] Load Stories', props<{ take?: number; skip?: number; theme?: number }>());
export const LoadStoriesSuccess = createAction('[Stories] Load Stories Success', props<{ stories: PagedOverview<Story> }>());
export const LoadStoriesFail = createAction('[Stories] Load Stories Fail', props<{ error: any }>());

export const LoadMoreStories = createAction('[Stories] Load MORE Stories');
export const LoadMoreStoriesSuccess = createAction('[Stories] Load MORE Stories Success', props<{ stories: PagedOverview<Story> }>());

export const UpdateStory = createAction('[Stories] Update Story', props<{ id: number; storyData: UpdateStoryData }>());
export const UpdateStorySuccess = createAction('[Stories] Update Story Success', props<{ story: Story }>());
export const UpdateStoryFail = createAction('[Stories] Update Story Fail', props<{ error: any }>());

export const CreateStory = createAction('[Stories] Create Story', props<{ storyData: StoryData }>());
export const CreateStorySuccess = createAction('[Stories] Create Story Success', props<{ story: Story }>());
export const CreateStoryFail = createAction('[Stories] Create Story Fail', props<{ error: any }>());

export const DeleteStory = createAction('[Stories] Delete Story', props<{ id: number }>());
export const DeleteStorySuccess = createAction('[Stories] Delete Story Success', props<{ story: Story }>());
export const DeleteStoryFail = createAction('[Stories] Delete Story Fail', props<{ error: any }>());

export const SetSortOrder = createAction('[Stories] Set Story Sort Order', props<{ order: number }>());
export const ClearStories = createAction('[Stories] Clear Stories');

export const LikeStory = createAction('[Stories] Like Story', props<{ id: number }>());
export const LikeStorySuccess = createAction('[Stories] Like Story Success', props<{ story: Story }>());
export const LikeStoryFail = createAction('[Stories] Like Story Fail', props<{ error: any }>());
